import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Transition from "../../../../../../../../../components/Transition";
import { AnimatePresence } from "framer-motion";
import { PayPalData } from "../network/api/PayPalData";

// Renders errors or successfull transactions on the screen.
function Message({ content }) {
    return <p>{content}</p>;
}

export default function PayPal({ credentialsPublic, createOrderPayload, setToastConfig, setSuccessPage }) {
    const isSandbox = Boolean(credentialsPublic?.sandbox);

    const initialOptions = {
        "client-id": credentialsPublic?.sandbox
            ? credentialsPublic.sandbox_credentials?.client_id
            : credentialsPublic.production_credentials?.client_id,
        "disable-funding": "paylater",
        ...(isSandbox ? { "buyer-country": "ZA" } : {}),
        currency: "USD",
        locale: "en_ZA",
        "data-page-type": "product-details",
        components: "buttons",
        "data-sdk-integration-source": "developer-studio",

    };

    const [geoLocation, setGeoLocation] = useState({"latitude": null, "longitude": null});

    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!navigator?.geolocation) {
            return;
        }

        navigator.geolocation.getCurrentPosition((position) => {
            setGeoLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            });
        });
    }, []);



    //functions

    const createOrder = async () => {
        try {
            const response = await PayPalData({payload: {
                ...createOrderPayload,
                geoLocation: geoLocation,
            }});

            if (response.status === "success") {
                return response.data.transaction_reference; 
            }
            else {
                setToastConfig({
                    message: `Could not initiate PayPal Checkout...${response.message}`,
                    type: "danger",
                    visible: true,
                });
                setMessage(`Could not initiate PayPal Checkout...${response.message}`);
            }
            
        } catch (error) {
            setToastConfig({
                message: `Could not initiate PayPal Checkout...${error}`,
                type: "danger",
                visible: true,
            });
            setMessage(`Could not initiate PayPal Checkout...${error}`);
        }
    }

    const cancelOrder = async (data) => {
        
        try {
            const response = await PayPalData({
                mode: "cancel",
                payload: {
                    ...createOrderPayload,
                    orderID: data.orderID,
                },
            });

            if (response.status === "success") {
                setToastConfig({
                    message: "Order cancelled.",
                    type: "warning",
                    visible: true,
                });
                setMessage("Order cancelled.");
            }
                
        } catch (error) {   
            setToastConfig({
                message: `Sorry, error while cancelling on order...${error}`,
                type: "danger",
                visible: true,
            });
            setMessage(`Sorry, error while cancelling on order...${error}`);
        }
    }

    const captureOrder = async (data, actions) => {
        try{
            const response = await PayPalData({
                mode: "capture",
                payload: {
                    ...createOrderPayload,
                    orderID: data.orderID,
                },
            });

            if (response.status === "success") {
                setToastConfig({
                    message: 'Thank you for your order! Your payment has been successfully captured.',
                    type: "success",
                    visible: true,
                });
                setMessage(`Thank you for your order! Your payment has been successfully captured.`);
                setSuccessPage(true);
               
            } else {
                setToastConfig({
                    message: `Sorry, error while capturing on order...${response.message}`,
                    type: "danger",
                    visible: true,
                });
                setMessage(`Sorry, error while capturing on order...${response.message}`);
            }
        }catch(errr){
            setToastConfig({
                message: `Sorry, error while capturing on order...${errr}`,
                type: "danger",
                visible: true,
            });
            setMessage(`Sorry, error while capturing on order...${errr}`);
        }
    }



    return (
        <AnimatePresence mode="wait" exitBeforeEnter>
            <Transition key={"paypal-page-trans"}>
                <div className=" col-12">
                    <div className=" bg-light rounded shadow-sm border-0 p-3">
                        
                        <div className="card-body pt-2">
                            <PayPalScriptProvider options={initialOptions}>
                                <PayPalButtons
                                    style={{
                                        layout: "vertical",
                                        color: "gold",
                                        shape: "rect",
                                        label: "pay",
                                        tagline: false,
                                    }}
                                    className="w-100"
                                    createOrder={createOrder}
                                    onApprove={captureOrder}
                                    onCancel={cancelOrder}
                                    onError={(err) => {
                                        setToastConfig({
                                            message: `Sorry, error while processing your order...${err}`,
                                            type: "danger",
                                            visible: true,
                                        });
                                        setMessage(`Sorry, error while processing your order...${err}`);
                                    }}

                                />
                            </PayPalScriptProvider>
                            <Message content={message} />
                        </div>
                    </div>
                </div>
            </Transition>
        </AnimatePresence>
    );
}
